var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 2.22217C7.85229 2.22217 6.11118 3.96328 6.11118 6.11106C6.11118 8.25883 7.85229 9.99995 10.0001 9.99995C12.1478 9.99995 13.889 8.25883 13.889 6.11106C13.889 3.96328 12.1478 2.22217 10.0001 2.22217ZM7.77785 6.11106C7.77785 4.88376 8.77277 3.88883 10.0001 3.88883C11.2274 3.88883 12.2223 4.88376 12.2223 6.11106C12.2223 7.33836 11.2274 8.33328 10.0001 8.33328C8.77277 8.33328 7.77785 7.33836 7.77785 6.11106Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0933 14.6964C14.864 12.4835 12.5315 11.1111 10.0001 11.1111C7.46861 11.1111 5.13615 12.4835 3.90677 14.6964L3.42159 15.5697C2.87124 16.5603 3.58757 17.7777 4.72081 17.7777H15.2793C16.4125 17.7777 17.1289 16.5603 16.5785 15.5697L16.0933 14.6964ZM5.3637 15.5058C6.29913 13.822 8.07389 12.7777 10.0001 12.7777C11.9262 12.7777 13.701 13.822 14.6364 15.5058L14.9727 16.1111H5.02743L5.3637 15.5058Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/iconPerson.e3efd8f14fd49661b2a1c9dbec560379.svg";
export { ForwardRef as ReactComponent };